export default __webpack_public_path__ + "static/media/recurrente.c811dfb1.png";